// removed by extract-text-webpack-plugin
module.exports = {"Footer":"_3p1oaiDw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer-component.styles.scss
// module id = 528
// module chunks = 0